export const getAnalyticsTrolleyItems = (state, lineNumber) =>
  state.trolley.analytics.trolleyItems[lineNumber];
